import debug from 'debug'

export const logDebug = debug('doveze:debug')
export const logPersist = debug('doveze:persist')
